import React, { useState } from "react";
import { functions } from "../firebase/firebase";
import {httpsCallable } from "firebase/functions";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const UpdateCommentForm = ({ stockId, existingComment, commentDate }) => {

  const [comment, setComment] = useState(existingComment || "");
  // const [message, setMessage] = useState("");

  // Function to handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the default form submission

    if (!comment.trim()) {
       toast.error("Comment cannot be empty.");
      return;
    }

    const updateComment = httpsCallable(functions, "updateComment");

    const payload = {
      Id: stockId,
      Comment: comment,
    };

    try {
      const response = await updateComment(payload);
      if (response.data.success) {
         toast.success("Update Comment successful!",{
          position: "bottom-right",
        });
      } else {
         toast.error("Failed to update. Please try again.");
      }
    } catch (error) {
      console.error("Error updating comment:", error);
      toast.error("Error updating comment.");
    }
  };

  return (
    <form className="edit-form" onSubmit={handleSubmit}>
      <table
        className="table-auto border-separate border-spacing-2"
        style={{ width: "100%", paddingLeft: "50px" }}
      >
        <tbody>
          <tr>
            {/* Comments and Last Comment Date */} 
            <td className="align-top">
              <strong className="text-xs font-semibold">Comments</strong>
              <br />
              <span className="text-xs ">Last comment on</span>
              <br />
              <span className="text-xs">{commentDate}</span>
            </td>

            {/* Textarea Input for Comments */}
            <td className="align-top w-3/4">
              <textarea
                rows="6"
                className="border-2 w-full h-40 p-2 text-xs border-gray-300 rounded-lg resize-none focus:outline-none"
                id="Comment"
                name="Comment"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder="Enter your comments here..."
              />
              <span className="text-xs text-gray-600">
                * Also include notes from Management Discussion & Analysis,
                Annual Report Schedules in separate headings
              </span>
            </td>

            {/* Save Button */}
            <td className="align-top">
              <button
                type="submit"
                className="bg-blue-500 text-white py-2 px-4 rounded-md text-sm uppercase tracking-wider hover:bg-blue-600"
              >
                Save
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      {/* Hidden Input for Stock ID */}
      {/* <input type="hidden" id="Id" name="Id" value={stockId} /> */}

    
    </form>
  );
};

export default UpdateCommentForm;
